import { writable } from 'svelte/store';
export const notif = writable(0); 
export const session = writable(0);
export const server = writable(0);
export const routerboard = writable(0);